import {inject, Injectable} from '@angular/core';
import {FilesApiService} from "../services-api/files-api.service";
import {UploadProgressService} from "./upload-progress.service";
import {ErrorService} from "./error.service";
import {FilesService} from "./files.service";
import {GetFileParams} from "../components/modals/files-modal/types/files-current-modal.types";
import {HttpEvent, HttpEventType} from "@angular/common/http";
import {ProgressStatus} from "../types/upload-progress.types";

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  private filesApiService: FilesApiService = inject(FilesApiService);
  private uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private errorService: ErrorService = inject(ErrorService);
  private filesService: FilesService = inject(FilesService);

  public async getFile(getFileParams: GetFileParams): Promise<void> {
    const { fileId, fileName } = getFileParams;
    return new Promise((resolve, reject) => {
      this.filesApiService.downloadFile(fileId).subscribe({
        next: (event) => {
          const progress = this.handleDownloadEvent(event, getFileParams);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: fileName,
            fileType: 'file',
          });
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        },
        complete: () => {
          setTimeout(() => {
            this.uploadProgressService.resetProgress();
            resolve();
          }, 300);
        }
      });
    });
  }

  private handleDownloadEvent(event: HttpEvent<Blob>, getFileParams: GetFileParams): ProgressStatus {
    const { fileName, fileSize, type, fileId } = getFileParams;

    switch (event.type) {
      case HttpEventType.DownloadProgress:
        const progress = Math.round(100 * event.loaded / (fileSize || 1));
        return { progress, completed: false };
      case HttpEventType.Response:
        const file = event.body as Blob;
        type === 'download'
          ? this.filesService.initiateFileDownload({ file, fileName })
          : this.filesService.handleFileBlob({ file, fileName, fileId });
        return { progress: 100, completed: true };
      default:
        return { progress: 0, completed: false };
    }
  }
}
